/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Row, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import TextAreaInput from 'components/input/TextAreaInput';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import {
  getAdditionalInfo,
  updateAdditionalInfo,
} from 'app/activitiesAndHonors/activitiesAndHonorsSlice';
import { HtmlTooltip } from 'screen/selectCollege/SelecCollegePage';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { debounce } from 'lodash';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { scrollToObject } from 'components/helper/ui_helper';
import Grid from '@mui/joy/Grid';
import websocketService from 'services/websocketService';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

interface Props {}

const AdditionalInfo = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const activitiesAndHonors = useAppSelector((store) => store.activitiesAndHonors);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  let studentId = getUserId();
  let token = getAccessToken();
  const query = new URLSearchParams(location.search);
  const check = query.get('check');
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndComplete(PAGE_NAME.ADDITIONAL_INFO, newValue);
    websocketService.finishReviewAndComplete(PAGE_NAME.ADDITIONAL_INFO_1, newValue);
    websocketService.finishReviewAndComplete(PAGE_NAME.ADDITIONAL_INFO_2, newValue);
    websocketService.finishReviewAndComplete(PAGE_NAME.ADDITIONAL_INFO_3, newValue);
  }
  const formik = useFormik({
    initialValues: {
      additional_comment_1: '',
      additional_comment_2: '',
      additional_comment_3: '',
      wish_to_provide_detail_of_circumstances_option: '',
      wish_to_share_option: '',
    },
    onSubmit: async (values) => {
      const newValues = {
        ...values,
        student_id: studentId,
      };
      await dispatch(updateAdditionalInfo(newValues));
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    history.push(routers.gpaForecaster.path.replace(':id', studentId));
  };


  const AutoScrollAndExpand = () => {
    const expandDiv = (divId:string) => {
      let div = document.getElementById(divId);
      if (div) {
        if (div.getAttribute('aria-expanded') === 'false') {
         div.click();
        }
      }
    }
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      if (hash) {
        //console.log('hash:', hash);
        if (hash==='wish_to_share_option') {
          setTimeout(() => {
            scrollToObject(hash, 200);
          }, 1500);
        } else
        if (hash==='additional_comment_3') {
          setTimeout(() => {
            scrollToObject(hash, 100);
          }, 1500);
        } else
        if (hash==='wish_to_provide_detail_of_circumstances_option') {
          setTimeout(() => {
            scrollToObject(hash, 100);
          }, 1500);
        } else
        if (hash==='additional_comment_1') {
          setTimeout(() => {
            scrollToObject(hash, 100);
          }, 1500);
        }
        
      } 
    }
    catch(ex){
      console.log('Error:', ex);
    }
  }

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.ADDITIONAL_INFO);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      const res = await dispatch(getAdditionalInfo(studentId));
      const dataLoaded = res.payload;
      if (dataLoaded) {
        formik.setValues({ ...formik.values, ...dataLoaded });
      }
      setTimeout(() => {
        AutoScrollAndExpand();
      }, 2000);
      setLoading(false);
      formik.setStatus('idle');

    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    const hash = location.hash.slice(1); // Remove the '#' character from the hash
    if (hash) {
      AutoScrollAndExpand();
    }
  }, [location]);


  // Auto save function ==========
  React.useEffect(() => {
    if (!!formik.status) debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  // Auto save function ==========
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: 'Challenges & Other Circumstances', 
            specialId: 'Challenges_Other_Circumstances',
            maxWidth: 180
          },
          { percentOnProcess: 60, title: 'Additional Info for Common App', 
            specialId: 'Additional_Info_Common_App',
            maxWidth: 120
          },
          { percentOnProcess: 90, title: 'Additional Comments for UC App', 
            specialId: 'Additional_Comments_UC_App',
            maxWidth: 140
          },
        ]}
        title="Additional Information"
        process={1}
        icon={<EventNoteOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <HtmlTooltip
              title={
                <React.Fragment>
                  <div className="fs-6 text-dark my-2 fw-bold">
                    <InfoOutlinedIcon fontSize="small" className="mx-1" />
                    Additional Information
                  </div>
                  <div className="d-flex flex-wrap text-field-light">
                    If there is anything else you'd like to colleges to consider beyond what you've
                    already included in your application, include them here. Please see our FAQs for
                    things to consider including.
                  </div>
                </React.Fragment>
              }
              placement="right-start"
            >
              <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                  Additional Information
                </span>
              </div>
            </HtmlTooltip>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div id="Challenges_Other_Circumstances" className={`${isMobile ? 'mb-2' : 'mb-3'} ${isMobile ? 'fs-6' : 'fs-5'}`}>Challenges or Other Circumstances</div>
              </Grid>
              <Grid xs={12}>
                <YesNoSwitch
                  disabled={reviewedAndComplete}
                  id="wish_to_share_option"
                  className="mb-3"
                  name="wish_to_share_option"
                  onChange={formik.handleChange}
                  values={formik.values.wish_to_share_option}
                  label="Would you like to share any details about challenges or other circumstances you've experienced*"
                  onClear={() => formik.setFieldValue('wish_to_share_option', '')}
                  isMissing={!formik.values.wish_to_share_option && check ? true : false}
                />
              </Grid>
              {formik.values.wish_to_share_option === 'true' && (
                <Grid xs={12}>
                  <TextAreaInput
                    disabled={reviewedAndComplete}
                    id="additional_comment_3"
                    className="common-flag"
                    logo="span-cm-logo"
                    isCMLogo={true}
                    mdCol="12"
                    label="Please use this space to describe how any challenges or other circumstances might have impacted your application and achievements.*"
                    name="additional_comment_3"
                    values={formik.values.additional_comment_3}
                    onChange={formik.handleChange}
                    countWord={250}
                    isOverCount={true}
                    rows={4}
                    isMissing={!formik.values.additional_comment_3 && check ? true : false}
                  />
                </Grid>
              )}
              <Grid xs={12}>
                <YesNoSwitch
                  disabled={reviewedAndComplete}
                  id="wish_to_provide_detail_of_circumstances_option"
                  className="mb-3"
                  name="wish_to_provide_detail_of_circumstances_option"
                  onChange={formik.handleChange}
                  values={formik.values.wish_to_provide_detail_of_circumstances_option}
                  label="Would you like to share any additional details or qualifications not reflected in this application?"
                  onClear={() =>
                    formik.setFieldValue('wish_to_provide_detail_of_circumstances_option', '')
                  }
                  isMissing={!formik.values.wish_to_provide_detail_of_circumstances_option && check ? true : false}
                />
              </Grid>
              {formik.values.wish_to_provide_detail_of_circumstances_option === 'true' && (
                <Grid id="Additional_Info_Common_App" xs={12}>
                  <TextAreaInput
                    disabled={reviewedAndComplete}
                    id="additional_comment_1"
                    logo="span-cm-logo"
                    mdCol="12"
                    label="Additional Information"
                    name="additional_comment_1"
                    values={formik.values.additional_comment_1}
                    onChange={formik.handleChange}
                    countWord={300}
                    isOverCount={true}
                    rows={4}
                    placeholder="Ex: 1st generation college student, changed high school, special circumstances, family issues, international student, if you were born outside of the U.S."
                    isMissing={!formik.values.additional_comment_1 && check ? true : false}
                  />
                </Grid>
              )}
              <Grid id="Additional_Comments_UC_App" xs={12}>
                <TextAreaInput
                  disabled={reviewedAndComplete}
                  logo="span-uc-logo"
                  mdCol="12"
                  label="Additional Comments"
                  name="additional_comment_2"
                  values={formik.values.additional_comment_2}
                  onChange={formik.handleChange}
                  countWord={550}
                  isOverCount={true}
                  rows={4}
                  isCMLogo={true}
                  placeholder="Ex: 1st generation college student, changed high school, special circumstances, family issues, international student, if you were born outside of the U.S."
                />
              </Grid>
            </Grid>

            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-start`}>
                <div className="d-flex flex-column align-items-start">
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}  
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed & Complete!
                    </span>
                  </div>
                </div>
              </div>
              
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {activitiesAndHonors.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'  
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </>
  );
};

export default AdditionalInfo;
